export default __webpack_public_path__ + "static/media/s1.b15584be.png";